import { Col, Form, Input, Modal, Row, Button, Select } from "antd";
import React, { memo, useState } from "react";
import { ToastError, ToastSuccess } from "../../components/ToastSwal";
import { PostListProjectDescription } from "../../api/APIProjectDescription";
const { Option } = Select;

const ModalAddProjectDescription = ({
  isModalOpenAddProject,
  handleOkAddProject,
  setIsModalOpenAddProject,
  fetchDataProjectDescription,
  ListValueProject,
}) => {
  const [form] = Form.useForm();
  const [searchKeywordProject, setSearchKeywordProject] = useState("");
  const [loadings, setLoadings] = useState(false);

  const handleCancelAddProject = () => {
    setIsModalOpenAddProject(false);
    form.resetFields();
  };

  const RsvntoRsjpOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' },
  ]
  
  const pricingModelOptions = [
    { value: 'Regular unit price', label: 'Regular unit price' },
    { value: 'Separate detail', label: 'Separate detail' },
    { value: 'Monthly fixed fee', label: 'Monthly fixed fee' },
    { value: 'Monthly minimum fee', label: 'Monthly minimum fee' },
  ]

  const projectStageOptions = [
    { value: 'New', label: 'New' },
    { value: 'Waiting', label: 'Waiting' },
    { value: 'On-going', label: 'On-going' },
    { value: 'Close', label: 'Close' },
  ]

  const onFinish = (values) => {
    // console.log("values", values);
    var FormData = require("form-data");
    var data = new FormData();
    setLoadings(!loadings);
    // console.log("values: ", values);
    
    // Loại bỏ giá trị null/undefined và nối chuỗi ko dấu cách
    var descriptionCode = [
      values.sub_project_name_1,
      values.sub_project_name_2,
      values.project_description
    ].filter(Boolean).join("");

    console.log('descriptionCode: ', descriptionCode);
    
    data.append("message", "create");
    data.append("project_code", values.project_name);
    data.append("description_code", descriptionCode);
    data.append("projectstage", values.project_stage);
    data.append("subprojectname1", values.sub_project_name_1 || "");
    data.append("subprojectname2", values.sub_project_name_2 || "");
    data.append("projectcription", values.project_description || "");
    data.append("pricingmodels", values.pricing_model || "");
    data.append("unit_price_total", values.unit_price_total);
    data.append("rsvn_to_rsjp", values.rsvn_to_rsjp);
    data.append("rsvn_to_rsjp_unit_price", values.rsvn_to_rsjp_unit_price);

    // for (var d of data.entries()) {
    //   console.log(d); 
    // }

    // currentDuAn
    PostListProjectDescription(data)
      .then((res) => {
        if (res.data.message === "Description đã tồn tại!") {
          // Không làm gì nếu project đã tồn tại
          ToastError.fire({
            icon: "error",
            title: res.data.message,
          });
          setLoadings(false); // Tắt trạng thái loading của nút Save
          return false; // Thoát khỏi hàm nếu đã tồn tại
        }
        
        ToastSuccess.fire({
          icon: "success",
          title: "Thêm mới Description thành công",
        });
        setLoadings(false);
        fetchDataProjectDescription();
        handleCancelAddProject();
      })
      .catch((error) => {
        ToastError.fire({
          icon: "error",
          title: error.data.message,
        });
      });
  };
  
  const handleSearchProject = (value) => {
    setSearchKeywordProject(value);
  };

  return (
    <Modal
      title="ADD PROJECT DESCRIPTION"
      open={isModalOpenAddProject}
      onOk={handleOkAddProject}
      onCancel={handleCancelAddProject}
      footer={false}
      width={800}
      forceRender={true}
      className="headerTitleModal"
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        initialValues={{
          remember: true,
        }}
      >
        <Row>
          <Col span={11}>
            <Form.Item
              label="Project Name"
              name="project_name"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn Project Name!",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="Project Name"
                showSearch
                onSearch={handleSearchProject}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={searchKeywordProject}
              >
                {ListValueProject.map((e) => (
                  <Option key={e.id} value={e.id}>
                    {e.projectname}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}></Col>
  
          <Col span={11}>
              <Form.Item
              label="Project Stage"
              name="project_stage"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập Project Stage!",
                  },
                ]}
              >
              <Select size="large" placeholder="Project Stage">
                {projectStageOptions.map((e) => (
                  <Option key={e.value} value={e.value}>
                    {e.label}
                  </Option>
                ))}
              </Select>
              </Form.Item>
          </Col>

          <Col span={11}>
              <Form.Item
              label="Sub Project Name 1"
              name="sub_project_name_1"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập Sub Project Name 1!",
                  },
                ]}
              >
                <Input size="large" placeholder="Sub Project Name 1" />
              </Form.Item>
          </Col>
            
          <Col span={2}></Col>

          <Col span={11}>
              <Form.Item
              label="Sub Project Name 2"
              name="sub_project_name_2"
                rules={[
                  {
                    message: "Vui lòng nhập Sub Project Name 2!",
                  },
                ]}
              >
                <Input size="large" placeholder="Sub Project Name 2" />
              </Form.Item>
          </Col>

          <Col span={11}>
              <Form.Item
              label="Project Description"
              name="project_description"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập Project Description!",
                  },
                ]}
              >
                <Input size="large" placeholder="Project Description" />
              </Form.Item>
          </Col>
          
          <Col span={2}></Col>

          <Col span={11}>
              <Form.Item
              label="Pricing Model"
              name="pricing_model"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn Pricing Model!",
                  },
                ]}
              >
                <Select size="large" placeholder="Pricing Model">
                {pricingModelOptions.map((e) => (
                  <Option key={e.value} value={e.value}>
                    {e.label}
                  </Option>
                ))}
              </Select>
              </Form.Item>
          </Col>
          
          <Col span={11}>
              <Form.Item
              label="Unit Price Total"
              name="unit_price_total"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập Unit Price Total!",
                  },
                  {
                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                    message: "Unit Price Total chỉ nhập số hoặc số thập phân!",
                  }
                ]}
              >
                <Input size="large" placeholder="Unit Price Total" />
              </Form.Item>
          </Col>
          
          <Col span={2}></Col>
          
          <Col span={11}>
            <Form.Item
              label="RSVN to RSJP"
              name="rsvn_to_rsjp"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn RSVN to RSJP!",
                },
              ]}
            >
              <Select size="large" placeholder="RSVN to RSJP">
                {RsvntoRsjpOptions.map((e) => (
                  <Option key={e.value} value={e.value}>
                    {e.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          
          <Col span={11}>
              <Form.Item
              label="RSVN to RSJP Unit Price"
              name="rsvn_to_rsjp_unit_price"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập RSVN to RSJP Unit Price!",
                  },
                  {
                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                    message: "RSVN to RSJP chỉ nhập số hoặc số thập phân!",
                  }
                ]}
              >
                <Input size="large" placeholder="RSJP to RSVN Unit Price" />
              </Form.Item>
          </Col>

          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              className="btnSaveModel"
              type="success"
              htmlType="submit"
              variant="contained"
              loading={loadings}
            >
              Save
            </Button>
            <Button
              className="btnCancelModel"
              variant="outlined"
              onClick={handleCancelAddProject}
            >
              Cancel
            </Button>
          </Col>
          <Col span={2}></Col>

        </Row>
      </Form>
    </Modal>
  );
};

export default memo(ModalAddProjectDescription);
